require('./scripts/_namespace')
require('./scripts/_modals-extension')
require('./scripts/locked-link')
require('./scripts/sticky-on-scroll')
require('./scripts/swiper')
require('./scripts/tabs')
require('./scripts/zoom-images')
require('./scripts/article-content')
require('./scripts/insta-embed')
require('./scripts/fb-embed')
require('./scripts/firebase')
require('./scripts/custom-multi-select')
